import { useEffect, useState } from "react";
import { CasProfileApi } from "@jti/rest-api";
export const useUserProfile = (isLoggedIn = false) => {
    const [isLoading, setIsLoading] = useState(false);
    const [userProfile, setUserProfile] = useState(null);
    useEffect(() => {
        if (!isLoggedIn) {
            return;
        }
        setIsLoading(true);
        CasProfileApi.init()
            .getProfile()
            .then((userProfileData) => {
            setUserProfile(userProfileData);
        })
            .catch((error) => {
            setUserProfile(null);
            console.error("Can't fetch user profile", error);
        })
            .finally(() => setIsLoading(false));
    }, [isLoggedIn]);
    return { isLoading, userProfile };
};
//# sourceMappingURL=useUserProfile.js.map